module.exports = __webpack_public_path__ + "img/ep-tipi.81fb6786.jpg";